import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import TopSearchesTabSection from './top-searches-tab-section';
import TopSearchesSection from './top-searches-section';
import { TopSearchesContent } from './top-search-style';
import { VotTopSearchesContainer } from './top-search-modern.style';

const TopSearches = ({ items, modern = false, vot = false }) => {
    if (vot) {
        return (
            <VotTopSearchesContainer className="vot-browse-links-content">
                <TopSearchesContent>
                    {items
                        .flatMap((search) => search.sections)
                        .map((section, index) => (
                            <TopSearchesSection key={index} {...section} />
                        ))}
                </TopSearchesContent>
            </VotTopSearchesContainer>
        );
    }

    return (
        <Fragment>
            {items.map((search, index) => (
                <div key={index}>
                    <TopSearchesTabSection isOpen={index === 0} modern={modern} {...search} />
                </div>
            ))}
        </Fragment>
    );
};

TopSearches.propTypes = {
    items: PropTypes.array.isRequired,
    modern: PropTypes.bool,
    vot: PropTypes.bool,
};

export default TopSearches;
